import React from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentProcessing = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
            <div className="bg-yellow-100 p-6 rounded-full mb-6">
                <svg className="w-16 h-16 text-yellow-600 animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
            </div>
            <h1 className="text-3xl font-bold text-gray-900 mb-4">Payment Processing</h1>
            <p className="text-lg text-gray-600 mb-8 max-w-md">
                Your payment is currently being processed by your bank. This usually takes a few minutes but can sometimes take longer. We will update your account as soon as the payment is confirmed.
            </p>
            <button
                onClick={() => navigate('/dashboard')}
                className="px-8 py-3 bg-primary text-white rounded-md font-medium hover:bg-primary-dark transition-colors"
            >
                Back to Dashboard
            </button>
        </div>
    );
};

export default PaymentProcessing;
